// extracted by mini-css-extract-plugin
export default {"menu":"NavBar_menu__jYHPh","menu-link":"NavBar_menu-link__HsfbB"};